'use strict';

const { getDependencyClass, phoenixCustomElement } = require('../../lib/dependencies.js');
import Splide from '@splidejs/splide';

getDependencyClass('phoenix-page').then((pageClass) => {
    /**
     * PhoenixQuoteMediaSlider is a web component
     * responsible for loading Slider widget on Quote Page
     *
     * @example
     *  <phoenix-quote-media-slider>
     *  </phoenix-quote-media-slider>
     */
    class PhoenixQuoteMediaSlider extends pageClass.PhoenixElement {
        connectedCallback() {
            super.connectedCallback();
            this.addEventListener('qmod-after-template-bind', () => {
                const splide = this.querySelector('.splide');
                setTimeout(() => {
                    new Splide(splide, {
                        type: 'loop',
                        perPage: 6,
                        perMove: 1,
                        gap: 20,
                        pagination: false,
                        breakpoints: {
                            992: {
                                perPage: 4,
                            },
                            742: {
                                perPage: 3,
                            },
                            480: {
                                perPage: 2,
                            },
                            320: {
                                perPage: 1,
                            },
                        },
                    }).mount();
                }, 0);
            });
        }
    }

    window.customElements.define('phoenix-quote-media-slider', PhoenixQuoteMediaSlider);
});
